import {mergeObjects} from './commonUtil';

export function prodEnvironment(countryCode, isAkamai) {
  let baseConfig = {
    exrEnv: 'prod',
    exrServiceApi: 'https://api.pd01e.gcp.ford.com/',
    submitAppPath: 'api/prequalify/rest/submit-application',
    onlineCreditApplicationTarget: 'https://www.oca.ford.com/finance/apply/',
    adobeSrc: 'https://assets.adobedtm.com/248d63c2ff6b/01cce4ecbac0/launch-EN69254704555044e1a0deab4d4b35f1ff.min.js',
    oneTrustCookieLawSrc: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    warningTimeMilliseconds: '900000',
    sessionEndTimeMilliseconds: '1800000',
    optimizelyKey: 'EVSfPEN5w4qJ1FbzVqgLe',
    prepopulateApprovedCustomerTestDataUSA: false,
    prepopulateCreditFreezeCustomerTestDataUSA: false,
    prepopulateApprovedCustomerTestDataCAN: false,
    prepopulateCreditFreezeCustomerTestDataCAN: false,
    prepopulateQuebecCreditFreezeCustomerTestDataCAN: false,
    modalFlag: false,
    specialEventTarget: 'https://www.buyfordnow.com/salesevent',
    showShadow: false,
    appModalURL: 'https://www.qualify.ford.com/webcompbutton/prequal-app-modal.js',
    minifiedCSSURL: 'https://www.qualify.ford.com/webcompbutton/prequal-app.css',
    AEM_PAGE_PATH: '/content/webplatform/ecommerce/qualify',
    AEM_PUBLISHER_URL: 'https://www.ford.com/finance',
    modelForApply: true,
    maintenanceModal: false,
    removeVehicleTrimInfoFlag: true,
    specialEventFlag: true,
    vehicleChooserVariation: 'vehicle_chooser_a_b',
    reCaptchaFlag: true,
    modalUpdateFlag: true,
    recaptchaVariation: 'exp_id_-_87'
  };

  const targetConfigUSA = {
    exploreFinancing: 'https://www.ford.com/finance/finance-options',
    exploreVehiclesTarget: 'https://shop.ford.com/showroom/',
    shopTarget: 'https://shop.ford.com/showroom/',
    ocaTarget: 'https://www.oca.ford.com/finance/apply/',
    exrTarget: 'https://www.prequalify.ford.com/finance/prequalify',
    countryCode: 'USA'
  };

  const targetConfigCanada = {
    exploreFinancing: 'https://www.ford.ca/finance/finance-options',
    exploreVehiclesTarget: 'https://shop.ford.ca/showroom/',
    shopTarget: 'https://shop.ford.ca/showroom/',
    ocaTarget: 'https://www.oca.ford.ca/finance/apply/',
    exrTarget: 'https://www.prequalify.ford.ca/finance/prequalify',
    countryCode: 'CAN'
  };

  baseConfig = mergeObjects(baseConfig, targetConfigUSA, targetConfigCanada, countryCode);

  const akamaiConfig = {
    exrTarget: countryCode === 'CAN' ? 'https://www.ford.ca/finance/prequalify' : 'https://www.ford.com/finance/prequalify',
    ocaTarget: countryCode === 'CAN' ? 'https://www.ford.ca/finance/apply/' : 'https://www.ford.com/finance/apply/'
  };
  if (isAkamai) {
    baseConfig = {...baseConfig, ...akamaiConfig};
  }
  return baseConfig;
}
